import { IconButton, Tooltip } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { MUIDataTableColumn, MUIDataTableOptions } from 'mui-datatables';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import appConfig from 'src/appConfig';
import { PATHS } from 'src/appConfig/paths';
import { Table, View } from 'src/components/common';
import { usersActions } from 'src/redux/usersRedux';
import { Navigator } from 'src/services';
import { IAppState } from 'src/store';
import { getSortParam, getUserPositionDisplay } from 'src/utils';
import NewUser from '../NewUser';
import { User } from '../type';

const TableContainer: React.FC<Props> = ({ content, onGetUsers }) => {
  const [records, setRecords] = useState<User[]>([]);
  const [total, setTotal] = useState<number>(0);
  // const [refresh, doRefresh] = useState<number>(0);
  const [isAddingUser, setIsAddingUser] = useState<boolean>(false);

  const handleGetUser = (params: any) => {
    var searchParam = params;
    if (searchParam.sort) {
      searchParam = {
        ...searchParam,
        sort: getSortParam(searchParam.sort),
      };
    }
    if (searchParam.order) {
      searchParam = {
        ...searchParam,
        order: searchParam.order.toUpperCase(),
      };
    }
    onGetUsers(searchParam, onGetUsersSuccess, onGetUsersFailed);
  };

  const onGetUsersSuccess = (res: { total: number; users: User[] }) => {
    const { total, users } = res;
    setRecords(users.map(u => ({ ...u, firstName: (u.firstName || '--') + ' ' + (u.lastName || '--') })));
    setTotal(total);
  };

  const onGetUsersFailed = (_err: any) => {};

  const handleRowClick = (_value: any, meta: { rowIndex: number }) => {
    const index = meta.rowIndex;
    const selectedRecord = records[index];
    Navigator.navigate(`${PATHS.ManageUsers}/${selectedRecord.id}`);
  };

  const handleOpenModalAddUser = () => {
    setIsAddingUser(true);
  };

  const handleCloseModalAddUser = (res: User) => {
    setIsAddingUser(false);
    if (res) Navigator.navigate(`${PATHS.ManageUsers}/${res.id}`);
  };

  const tableOptions: MUIDataTableOptions = {
    rowsPerPageOptions: appConfig.ROWS_PER_PAGE_OPTIONS,
    count: total,
    onRowClick: handleRowClick,
    customToolbar: () => (
      <Tooltip title={'Create a New User'}>
        <IconButton onClick={handleOpenModalAddUser}>
          <Add />
        </IconButton>
      </Tooltip>
    ),
  };

  const roles = content?.userRoles?.map((x: any) => x.key);

  const columns: MUIDataTableColumn[] = [
    {
      name: 'name',
      label: 'Name',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: string) => {
          return <p>{!!value ? value : '--'}</p>;
        },
      },
    },
    { name: 'email', label: 'Email', options: { filter: false, sort: true } },
    {
      name: 'mobile',
      label: 'Phone Number',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: string) => {
          return <p>{!!value ? value : '--'}</p>;
        },
      },
    },
    {
      name: 'companyOrLawFirm',
      label: 'Company/Law Firm',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: string) => {
          return <p>{!!value ? value : '--'}</p>;
        },
      },
    },
    {
      name: 'role',
      label: 'User Role',

      options: {
        filter: true,
        filterOptions: {
          names: roles,
          fullWidth: true,
        },
        sort: true,
        customBodyRender: (value: string) => {
          return <p style={{ textTransform: 'capitalize' }}>{!!value ? getUserPositionDisplay(value) : '--'}</p>;
        },
      },
    },
  ];

  // const isShowModal = !!recordDetail;

  return (
    <View className="mt-32">
      {isAddingUser && <NewUser onClose={handleCloseModalAddUser} />}
      <Table
        title="Manage Users"
        data={records}
        tableOptions={tableOptions}
        columns={columns}
        onAction={handleGetUser}
        // refresh={refresh}
      />
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

const mapStateToProps = (state: IAppState) => ({
  isLoading: state.common.isLoading,
  content: state.content,
});

const mapDispatchToProps = {
  onGetUsers: usersActions.getUsers,
};

export default connect(mapStateToProps, mapDispatchToProps)(TableContainer);
